// This is generated.  Alter it in blockGroups/formElements/types/FormCardList.js
/* eslint-disable no-unused-vars */
const formList = require('./ReadOnlyFormList');
const { moduleRegistration } = require('@sstdev/lib_metadata-config');
module.exports = {
  asDataDictionary: function asDataDictionary(hNode, context) {
    return formList.asDataDictionary(hNode, context);
  },
};
moduleRegistration.registerHNodeType(
  'formElements',
  'FormCardList',
  module.exports,
);
